<template>
    <div class="informationPage">
        <template v-if="mixinUserInfo.platformType != 1">
            <div class="formTitle">车辆信息</div>
            <Card header="基础信息">
                <el-form label-width="120px" label-position="left">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="车辆号牌">
                                <span v-if="info.licenseNo" :style="getPlateStyle(info.licenseNo)">{{ formatPlateNumber(info.licenseNo) }}</span>
                                <span v-else>-</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="号牌颜色">
                                <span>{{ info.licenseColor || '-' }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="机构名称">
                                <span>{{ info.organizationName || '-' }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="车辆型号">
                                <span>{{ info.vehicleModel || '-' }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="车身颜色">
                                <span>{{ info.vehicleColor || '-' }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="核载人数">
                                <span>{{ info.vehicleSeat || '-' }}座</span>
                            </el-form-item>
                        </el-col>
                        <template v-if="mixinUserInfo.platformType === 1 || mixinUserInfo.platformType === 2">
                            <el-col :span="8">
                                <el-form-item label="车辆责任人">
                                    <span>{{ info.vehicleResponsible || '-' }}</span>
                                    <el-button type="text" size="medium" @click="editCompany">
                                        <i class="el-icon-edit"></i>
                                    </el-button>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="车辆所属">
                                    <span>{{ info.companyName || '-' }}</span>
                                    <el-button type="text" size="medium" @click="editCompany">
                                        <i class="el-icon-edit"></i>
                                    </el-button>
                                </el-form-item>
                            </el-col>
                        </template>
                        <el-col :span="8" v-if="mixinUserInfo.platformType === 3">
                            <el-form-item label="归属渠道">
                                <span>{{ info.channelName || '-' }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </Card>

            <Card header="业务信息" style="margin-top: 20px;" v-if="mixinUserInfo.platformType === 2">
                <el-form label-width="120px" label-position="left">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="随车人数">
                                <span>{{ info.followPersonnelSeat || 0 }}人</span>
                                <el-button type="text" size="medium" @click="editPassengers">
                                    <i class="el-icon-edit"></i>
                                </el-button>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="授权排班机构">
                                {{ authOrganizationText }}
                                <el-button type="text" size="medium" @click="editAuthOrg">
                                    <i class="el-icon-edit"></i>
                                </el-button>

                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </Card>

            <div class="formTitle" style="margin-top: 32px;">证件信息</div>

            <Card>
                <div slot="header" class="flex" style="justify-content: space-between;">
                    <span>行驶证</span>
                    <el-button type="text" size="medium" @click="editDriving">更新</el-button>
                </div>
                <el-form label-width="120px" label-position="left">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="行驶证正页">
                                <el-image v-if="info.drivingLicenseFront" :src="mixinQiniuImg(info.drivingLicenseFront)"
                                    style="width: 200px; height: 135px;" fit="cover"
                                    :preview-src-list="[mixinQiniuImg(info.drivingLicenseFront)]"></el-image>
                                    <span>-</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="行驶证副页">
                                <el-image v-if="info.drivingLicenseFront" :src="mixinQiniuImg(info.drivingLicenseBack)"
                                    style="width: 200px; height: 135px;" fit="cover"
                                    :preview-src-list="[mixinQiniuImg(info.drivingLicenseBack)]"></el-image>
                                <span v-else>-</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="车辆识别代号">
                                <span>{{ info.vin }}</span>
                            </el-form-item>
                            <el-form-item label="使用性质">
                                <span>{{ info.useCharacter }}</span>
                            </el-form-item>
                            <el-form-item label="注册日期">
                                <span>{{ info.registerDate | filterTime('YYYY-MM-DD') }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </Card>

            <Card style="margin: 20px 0;" v-if="mixinUserInfo.platformType === 1 || mixinUserInfo.platformType === 2">
                <div slot="header" class="flex" style="justify-content: space-between;">
                    <span>道路运输证</span>
                    <el-button type="text" size="medium" @click="editRoad">更新</el-button>
                </div>
                <el-form label-width="120px" label-position="left">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="证件照片">
                                <el-image :src="mixinQiniuImg(info.roadTransportCertificate)"
                                    style="width: 200px; height: 135px;" fit="cover"
                                    :preview-src-list="[mixinQiniuImg(info.roadTransportCertificate)]"></el-image>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </Card>
        </template>

        <div class="dz-page" v-else>
            <el-descriptions :column="2" label-position="left" label-width="120px" size="medium" border>
                <el-descriptions-item label="车辆号牌">
                    <span v-if="info.licenseNo" :style="getPlateStyle(info.licenseNo)" @dblclick="$utils.dblclickCopy">{{ formatPlateNumber(info.licenseNo) }}</span>
                    <span v-else>-</span>
                </el-descriptions-item>
                <el-descriptions-item label="车辆识别代码">
                    <span @dblclick="$utils.dblclickCopy">{{ info.vin || '-' }}</span>
                </el-descriptions-item>
                <el-descriptions-item label="车辆使用性质">
                    {{ info.useCharacter || '-' }}
                </el-descriptions-item>
                <el-descriptions-item label="车辆注册日期">{{ info.registerDate | filterTime('YYYY-MM-DD')
                    }}</el-descriptions-item>
                <el-descriptions-item label="行驶证正页">
                    <el-image :src="mixinQiniuImg(info.drivingLicenseFront)" style="width: 200px; height: 135px;"
                        fit="cover" :preview-src-list="[mixinQiniuImg(info.drivingLicenseFront)]"></el-image>
                </el-descriptions-item>
                <el-descriptions-item label="行驶证副页">
                    <el-image :src="mixinQiniuImg(info.drivingLicenseBack)" style="width: 200px; height: 135px;"
                        fit="cover" :preview-src-list="[mixinQiniuImg(info.drivingLicenseBack)]"></el-image>
                </el-descriptions-item>
                <el-descriptions-item label="道路运输证">
                    <el-image :src="mixinQiniuImg(info.roadTransportCertificate)" style="width: 200px; height: 135px;"
                        fit="cover" :preview-src-list="[mixinQiniuImg(info.roadTransportCertificate)]"></el-image>
                </el-descriptions-item>
            </el-descriptions>
        </div>

        <DrivingDialog :visible.sync="drivingDialogVisible" :info="info" :loading="loading"
            @submit="handleDrivingSubmit">
        </DrivingDialog>
        <RoadDialog :visible.sync="roadDialogVisible" :info="info" :loading="loading" @submit="handleRoadSubmit">
        </RoadDialog>

        <el-dialog title="车辆归属" :visible.sync="editCompanyVisible" width="400px" :close-on-click-modal="false">
            <el-form :model="editCompanyForm" :rules="editCompanyRules" ref="editCompanyForm" label-width="120px"
                label-position="left">
                <el-form-item label="车辆责任人" prop="vehicleResponsible">
                    <el-input v-model="editCompanyForm.vehicleResponsible" maxlength="10"></el-input>
                </el-form-item>
                <el-form-item label="车辆所属" prop="companyName">
                    <el-input v-model="editCompanyForm.companyName" maxlength="20"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button size="medium" @click="editCompanyClose">取 消</el-button>
                <el-button size="medium" type="primary" @click="editCompanySave" :loading="loading">确 认</el-button>
            </div>
        </el-dialog>


        <el-dialog title="随车人数" :visible.sync="passengerDialogVisible" width="400px" :close-on-click-modal="false">
            <el-form :model="passengerForm" :rules="passengerRules" ref="passengerForm" label-width="120px"
                label-position="left">
                <el-form-item label="随车人数" prop="followPersonnelSeat">
                    <el-select v-model="passengerForm.followPersonnelSeat" filterable>
                        <el-option v-for="(item, index) in 6" :label="`${index}人`" :value="index"
                            :key="index"></el-option>
                    </el-select>
                    <div class="tips" style="font-size: 12px;">添加随车人数后，即减少对应车辆可售座位数</div>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button size="medium" @click="closePassengerDialog">取 消</el-button>
                <el-button size="medium" type="primary" @click="savePassengerCount" :loading="passengerLoading">确
                    认</el-button>
            </div>
        </el-dialog>
        <el-dialog title="授权排班" :visible.sync="authOrgDialogVisible" width="400px" :close-on-click-modal="false">
            <el-form :model="authOrgForm" :rules="authOrgRules" ref="authOrgForm" label-width="120px"
                label-position="left">
                <el-form-item label="授权机构" prop="authOrganizationId">
                    <el-select :disabled="!authOrgForm.organizationId" v-model="authOrgForm.authOrganizationId" multiple
                        filterable>
                        <el-option :disabled="item.id == authOrgForm.organizationId"
                            v-for="(item, i) in organizationsAll" :key="i" :value="item.id" :label="item.name">
                        </el-option>
                    </el-select>
                    <div class="tips" style="font-size: 12px;">可授权给其他机构报班、排班授权</div>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button size="medium" @click="closeAuthOrgDialog">取 消</el-button>
                <el-button size="medium" type="primary" @click="saveAuthOrg" :loading="authOrgLoading">确 认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import DrivingDialog from './DrivingDialog.vue'
import RoadDialog from './RoadDialog.vue'

export default {
    components: {
        DrivingDialog,
        RoadDialog
    },
    data() {
        return {
            drivingDialogVisible: false,
            roadDialogVisible: false,
            loading: false,

            editCompanyVisible: false,
            editCompanyForm: {
                vehicleResponsible: '',
                companyName: ''
            },
            editCompanyRules: {
                vehicleResponsible: [{ required: false, message: '请输入车辆责任人' }],
                companyName: [{ required: false, message: '请输入车辆所属' }]
            },

            passengerDialogVisible: false,
            authOrgDialogVisible: false,
            passengerLoading: false,
            authOrgLoading: false,
            passengerForm: {
                followPersonnelSeat: ''
            },
            authOrgForm: {
                authOrganizationId: ''
            },
            passengerRules: {
                passengerCount: [{ required: true, message: '请输入随车人数' }]
            },
            authOrgRules: {
                authOrganizationId: [{ required: true, message: '请输入授权机构' }]
            },
            organizationsAll: []
        }
    },
    computed: {
        authOrganizationText() {
            let authOrganizationIds = this.info.authOrganizationId?.split(',').map(Number) || []
            let authOrganizationText = this.organizationsAll.filter(item => authOrganizationIds.includes(item.id)).map(item => item.name).join(',')
            return authOrganizationText || '-'

        }
    },
    props: {
        info: {
            type: Object,
            default: () => ({})
        }
    },
    created() {
        this.getOrganizationsAll()
    },
    methods: {
        async getOrganizationsAll() {
            let url = '/api/v1/manage/organization/queryAll';
            let data = await this.$axios.get(url);
            if (data && data.code === 1) {
                this.organizationsAll = data.data
            }
        },
        editPassengers() {
            this.passengerDialogVisible = true
            this.passengerForm.followPersonnelSeat = this.info.followPersonnelSeat
        },
        editAuthOrg() {
            this.authOrgDialogVisible = true
            this.authOrgForm.organizationId = this.info.organizationId
            this.authOrgForm.authOrganizationId = this.info.authOrganizationId?.split(',').map(Number) || []
        },
        closePassengerDialog() {
            this.passengerDialogVisible = false
        },
        closeAuthOrgDialog() {
            this.authOrgDialogVisible = false
        },
        savePassengerCount() {
            this.$refs.passengerForm.validate(async (valid) => {
                if (valid) {
                    let url = '/api/v1/manage/vehicle'
                    let params = {
                        // id: this.info.id,
                        // organizationId: this.info.organizationId,
                        // licenseNo: this.info.licenseNo,
                        // authOrganizationId: this.info.authOrganizationId,
                        ...this.info,
                        followPersonnelSeat: this.passengerForm.followPersonnelSeat,
                    }
                    this.passengerLoading = true
                    let data = await this.$axios.put(url, params);
                    if (data && data.code === 1) {
                        this.$message.success("保存成功！");
                        this.passengerDialogVisible = false
                        this.$emit("refresh");
                    }
                    this.passengerLoading = false
                }
            })
        },
        saveAuthOrg() {
            this.$refs.authOrgForm.validate(async (valid) => {
                if (valid) {
                    let url = '/api/v1/manage/vehicle'
                    let params = {
                        // id: this.info.id,
                        // organizationId: this.info.organizationId,
                        // licenseNo: this.info.licenseNo,
                        ...this.info,
                        authOrganizationId: this.authOrgForm.authOrganizationId.toString()
                    }
                    this.authOrgLoading = true
                    let data = await this.$axios.put(url, params);
                    if (data && data.code === 1) {
                        this.$message.success("保存成功！");
                        this.authOrgDialogVisible = false
                        this.$emit("refresh");
                    }
                    this.authOrgLoading = false
                }
            })
        },
        editDriving() {
            this.drivingDialogVisible = true
        },
        editRoad() {
            this.roadDialogVisible = true
        },
        async handleDrivingSubmit(formData) {
            this.loading = true
            let url = "/api/v1/manage/vehicle";
            let params = {
                ...this.info,
                ...formData,
                // id: this.info.id,
                // organizationId: this.info.organizationId,
                // authOrganizationId: this.info.authOrganizationId,
            }
            let data = await this.$axios.put(url, params);
            if (data && data.code === 1) {
                this.$emit('refresh')
                this.$message.success("保存成功！");
                this.drivingDialogVisible = false
            }
            this.loading = false
        },
        async handleRoadSubmit(formData) {
            this.loading = true
            let url = "/api/v1/manage/vehicle";
            let params = {
                // id: this.info.id,
                // organizationId: this.info.organizationId,
                // licenseNo: this.info.licenseNo,
                ...this.info,
                roadTransportCertificate: formData.roadTransportCertificate,
                authOrganizationId: this.info.authOrganizationId,
            }
            let data = await this.$axios.put(url, params);
            if (data && data.code === 1) {
                this.$emit('refresh')
                this.$message.success("保存成功！");
                this.roadDialogVisible = false
            }
            this.loading = false
        },
        editCompany() {
            this.editCompanyVisible = true
            this.editCompanyForm.vehicleResponsible = this.info.vehicleResponsible
            this.editCompanyForm.companyName = this.info.companyName
        },
        editCompanyClose() {
            this.editCompanyVisible = false
        },
        editCompanySave() {
            this.$refs.editCompanyForm.validate(async (valid) => {
                if (valid) {
                    let url = '/api/v1/manage/vehicle'
                    let params = {
                        // id: this.info.id,
                        // organizationId: this.info.organizationId,
                        // licenseNo: this.info.licenseNo,
                        // authOrganizationId: this.info.authOrganizationId,
                        ...this.info,
                        vehicleResponsible: this.editCompanyForm.vehicleResponsible,
                        companyName: this.editCompanyForm.companyName
                    }
                    this.loading = true
                    let data = await this.$axios.put(url, params);
                    if (data && data.code === 1) {
                        this.$message.success("保存成功！");
                        this.editCompanyVisible = false
                        this.$emit("refresh");
                    }
                    this.loading = false
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.informationPage {

    // width: 700px;
    /deep/ .el-image__inner {
        border-radius: 4px;
    }

    .content {
        border: 1px solid #EEEEEEEE;
        border-radius: 4px;
        padding: 20px 20px 0 20px;
        align-items: flex-start;
        justify-content: space-between;

        &>div {
            width: 33%;
        }
    }

    .dz-page {
        height: 100%;

        :deep(.el-descriptions) {
            border-radius: 8px;
            position: relative;
            overflow: hidden;
        }

        :deep(.el-descriptions)::after {
            content: '';
            pointer-events: none;
            position: absolute;
            inset: 0;
            border-radius: 8px;
            border: 1px solid #EBEEF5;
            z-index: 1;
        }

        :deep(.el-descriptions-row) {
        display: flex;
    }

    :deep(.el-descriptions-item__cell) {
        border-top: 0;
        border-left: 0;
    }

    :deep(.el-descriptions-item__label.is-bordered-label) {
        width: 150px;
        flex-shrink: 0;
        background-color: #FBFBFB;
    }

    :deep(.el-descriptions-item__content) {
        flex: 1;
    }
    }
}
</style>